import React, { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { HIDE_FLASH_BANNER } from '@consts/index'
import { useRouter } from 'next/router'

import styles from './styles.module.scss'
import { RootState } from '@store/redux/reducers'
import { NotificationBannerState } from '@store/redux/reducers/otherReducers'
import PromoBanner from './PromoBanner'
import AppContext from '@components/AppContext'
import PushNotificationBanner from './PushNotificationBanner'
import { hasFreeShippingExperiment } from '@components/cart/CartSideDrawerOverlay/CartSideDrawer'
import { fetchContentFulData } from '@helpers/contentful'
import { FlashBannerItem } from 'types/contentful/graphQlApi'
import useIsReactClient from '@helpers/hooks/useIsReactClient'
import trackError from '@helpers/trackError'

const FlashBanner = () => {
  const router = useRouter()
  const { flashBanner } = useContext(AppContext)
  const { showBanner, ...banner } = flashBanner || {}
  const [campaignPromoBanner, setCampaignPromoBanner] =
    useState<FlashBannerItem | null>(null)
  const isReactClient = useIsReactClient()

  const notificationBanner = useSelector<RootState, NotificationBannerState>(
    state => state.notificationBanner
  )
  const isDynamicFlashBannerVisible =
    Object.keys(banner).length > 0 &&
    showBanner &&
    !HIDE_FLASH_BANNER.includes(router.query.pagesHandle?.toString?.() ?? '')

  const isFreeShippingPromo =
    !!banner &&
    hasFreeShippingExperiment() &&
    'messageDesktop' in banner &&
    banner.messageDesktop?.includes('free delivery')

  useEffect(() => {
    if (!isFreeShippingPromo) {
      setCampaignPromoBanner(null)
      return
    }
    let isMounted = true
    const fetchCampaignPromoBanner = async () => {
      try {
        const promoBanner = (await fetchContentFulData({
          id: '1mJYl6xgEYh3dEYSh6vGWM',
          depth: 10,
          unNest: false,
          isPreview: true
        })) as FlashBannerItem

        if (isMounted) {
          setCampaignPromoBanner(promoBanner ?? null)
        }
      } catch (error) {
        if (isMounted) {
          setCampaignPromoBanner(null)
        }

        trackError(new Error('Failed to fetch Contentful Flash Banner Item'), {
          section: 'Promo Banner',
          error: error as Error
        })
      }
    }

    fetchCampaignPromoBanner()

    return () => {
      isMounted = false
    }
  }, [isFreeShippingPromo])

  return (
    <>
      <PushNotificationBanner {...notificationBanner} />
      {isDynamicFlashBannerVisible && (
        <section data-testid="DynamicFlashBanner" className={styles.flash}>
          {campaignPromoBanner && isReactClient ? (
            <PromoBanner {...campaignPromoBanner} />
          ) : (
            <PromoBanner {...banner} />
          )}
        </section>
      )}
    </>
  )
}

export default FlashBanner
